const mailAddresses = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)/;
const phoneNumbers = /0[5789]0[0-9]{8}/;
const piiPatterns = [mailAddresses, phoneNumbers];

function isPIILeakSuspected(message) {
	if (message === undefined) {
		return false
	}

	return piiPatterns.some((p) => p.test(message))
}

function maskMessage(message) {
	return isPIILeakSuspected(message) ? '[REDACTED] PII Leak suspected message' : message
}

function ignoreOldBrowser(ua) {
	// Chrome (not on IOS) は user agent 文字列に Safari が含まれるので Safari チェック後に除外
	// Mozilla/5.0 (Macintosh; Intel Mac OS X 14_0_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/117.0.5938.92 Safari/537.36
	// Chrome on iOS の user-agent は "Chrome" を含まず CriOS となる
	// Mozilla/5.0 (iPad; CPU OS 14_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/1.0.7.0 Mobile/15E148 Safari/605.1
	if (ua.includes('Chrome')) {
		return false;
	}

	// iOS, iPadOS は 14 以下除外
	// iOS の webview 系は Version が存在しないので iOS/iPad OS で判定
	// Mozilla/5.0 (iPhone; CPU iPhone OS 14_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.0 Mobile/15E148 Safari/604.1
	// Mozilla/5.0 (iPad; CPU OS 14_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/1.0.7.0 Mobile/15E148 Safari/605.1
	// Mozilla/5.0 (iPhone; CPU iPhone OS 14_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 Safari Line/10.14.0
	const ios = /(?:iPhone OS|iPad; CPU OS) (\d+)_/.exec(ua);
	if (ios && ios[1] && parseInt(ios[1], 10) <= 14) {
		return true;
	}

	// macOS の場合は version から取得
	// Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.0.2 Safari/605.1.15
	if (ua.includes('Mac OS X') && !ua.includes('iPhone') && !ua.includes('iPad')) {
		const mac = /Version\/(\d+)\./.exec(ua);
		if (mac && mac[1] && parseInt(mac[1], 10) <= 14) {
			return true;
		}
	}

	return false;
}

window.sentryOnLoad = function () {
	Sentry.init({
		sampleRate: 0.005,
		// Performance Monitoring
		tracesSampleRate: 0.001,
		// Session Replay
		replaysSessionSampleRate: 0,
		replaysOnErrorSampleRate: 0,
		environment: (() => {
			const environments = {
					"otoriyose.ikyu.com": "production",
					"stg-otoriyose.ikyu.com": "staging",
					"dev-otoriyose.ikyu.com": "development",
			};

			// ホスト名に基づいて環境を決定し、デフォルトは "development"
			console.log('Sentry environment:', environments[location.hostname]);
			return environments[location.hostname] || "development";
		})(),
		beforeSend(event, _hint) {
			try {
				// ignore old browsers
				if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined') {
					if (ignoreOldBrowser(window.navigator.userAgent)) {
						return null
					}
				}
				if (event.message) {
					event.message = maskMessage(event.message)
				}
				if (event.request?.query_string) {
					const qp = event.request.query_string
					if (typeof qp === 'string') {
						event.request.query_string = maskMessage(qp)
					} else if (Array.isArray(qp)) {
						event.request.query_string = qp.map(
							([k, v]) => [k, maskMessage(v)]
						)
					} else {
						for (const k in qp) {
							qp[k] = maskMessage(qp[k])
						}
					}
				}
				if (event.exception && event.exception.values) {
					event.exception = {
						values: event.exception.values.map((e) => {
							if (e.value) {
								e.value = maskMessage(e.value)
							}
							return e
						}),
					}
				}
			} catch (error) {
				console.error("beforeSendでエラーが発生しました:", error);
			}
			
			return event
		},
	});
};